<script>
import ResourceService from '@/services/resources/allocation_units_service';
import AdminView from './AdminView.vue';

export default {
  extends: AdminView,
  components: {
    ActionBar: () => import('@/components/action_bars/AllocationUnitsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-washing-machine',
      urlFragment: 'allocation-units',
      resourceParams: {
        include: 'site,site.chemical-manufacturer',
        fields: {
          sites: 'name,chemical-manufacturer',
          'allocation-units': 'name,site,last-dispense-time,last-sync-time',
          'chemical-manufacturers': 'name',
        },
      },
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Site', value: 'site.name' },
        { text: 'Manufacturer', value: 'site.chemicalManufacturer.name' },
        { text: 'Last Dispense', value: 'lastDispenseTime' },
        { text: 'Last Sync', value: 'lastSyncTime' },
      ],
      sortBy: ['name'],
    };
  },
};
</script>
